import { Avatar, AvatarImage } from '@/design-system/avatar';

interface IUserInfo {
  profile: {
    path: string;
    alt: string;
  };
  name: string;
  userId: string;
  reservationCount: number;
}
export const UserInfo = ({ name = '', profile, reservationCount = 0, userId = '' }: IUserInfo) => {
  return (
    <div className="flex justify-between ">
      <div className="flex gap-1 items-center">
        <Avatar>
          <AvatarImage className="object-cover" src={profile?.path || ''} alt={profile?.alt || ''} />
        </Avatar>
        <div>
          <div className="text-sm capitalize font-medium  leading-[100%]">{name}</div>
          <div className="text-xs">@{userId}</div>
        </div>
      </div>
      <div className="text-md items-start font-display">
        {reservationCount} <span className="text-micro">人</span>
      </div>
    </div>
  );
};
